module.exports = __webpack_public_path__ + "static/media/lumensearch.72cc42c0.png";